// Avantages du statut « Organisateur certifie », tels que presentes au membre invite.
// Miroir des privileges de functions/src/services/organizerPrivileges.js (ADR-019) :
// a mettre a jour a chaque nouveau privilege.
export const CERTIFIED_ORGANIZER_PERKS = Object.freeze([
  {
    id: "badge",
    icon: "🏅",
    title: "Le badge « Organisateur certifié »",
    description: "Il apparaît sur ton profil et à côté du titre de tes sorties. Un clic explique qu'il est attribué par KARANGO.",
  },
  {
    id: "capacity",
    icon: "👥",
    title: "Jusqu'à 30 participants",
    description: "La jauge de tes sorties passe de 10 à 30 places.",
  },
  {
    id: "spotlight",
    icon: "⭐",
    title: "Ta sortie « À la une »",
    description: "Ta prochaine sortie publique passe en tête du carrousel « À la une », en haut de la liste des sorties.",
  },
  {
    id: "interested",
    icon: "📣",
    title: "Prévenir aussi les intéressés",
    description: "Quand tu envoies une annonce à tes participants, tu peux aussi prévenir ceux qui ont mis « M'intéresse », par notification et push.",
  },
  {
    id: "advanced-options",
    icon: "🔒",
    title: "Les options de visibilité avancées",
    description: "Réserver une sortie aux nouveaux venus (« sauf ceux déjà venus X fois ») ou la rendre visible seulement avec un lien et un code.",
  },
  {
    id: "events-link",
    icon: "🔗",
    title: "Le lien de toutes tes sorties",
    description: "Un lien à partager (WhatsApp, SMS, réseaux) qui montre toutes tes prochaines sorties publiques.",
  },
]);
